<template>
  <slot>
    <div :class="wrapperClasses" :id="identifier" v-show="!state.hidden">
      <fieldset class="govuk-fieldset" :aria-describedby="hintId">
        <label class="govuk-fieldset__legend" :for="controlId" v-show="!state.hiddenLabel" v-html="displayName"> </label>
        <span :id="titleId" class="govuk-title" v-html="displayTitle"></span>

        <div :class="displayHintClasses" v-if="displayHint" v-on:click="toggleHintSection" v-html="displayHintText"></div>
        <div :id="hintId" class="govuk-hint" v-show="!state.hiddenHint" v-html="displayHint"></div>

        <span :id="errorId" class="govuk-error-message">
          <ul v-if="currentErrors.length > 0">
            <li v-for="(errorMessage, errIndex) in currentErrors" v-bind:key="errIndex">
              {{ errorMessage.message }}
            </li>
          </ul>
        </span>
        <div class="govuk-radios">
          <div class="govuk-radios__item" v-for="(option, index) in options" :key="index">
            <input
              class="govuk-radios__input"
              :id="identifier + '_' + index"
              :name="identifier + '-group'"
              :value="option.Value"
              :disabled="option.Disabled ? option.Disabled : false"
              type="radio"
              v-model="state.value"
            />
            <label class="govuk-label govuk-radios__label" title="Vyberte jednu z možností. " :for="identifier + '_' + index">
              {{ option.Text }}
            </label>
          </div>
        </div>
      </fieldset>
    </div>
  </slot>
</template>
<script lang="ts" src="@/library/templates/default/controls/RadioButtonList.ts"></script>
